export enum QuickStepsLoadState {
    Uninitialized,
    Loading,
    Loaded,
    ConfigError,
}
